export interface LogResult {
  saved: boolean;
}
